<template>
<v-list-item @click="$emit('click', data, website, websiteType)" >
  <v-list-item-action v-if="website && website.id" >
    <v-btn icon small color='error' @click.stop='$emit("destroy", website.id)' >
      <v-icon small >mdi-delete</v-icon>
    </v-btn>
  </v-list-item-action>
  <v-list-item-content>
    <v-list-item-title>{{title}}</v-list-item-title>
    <v-list-item-subtitle v-if="website && website.id" >
      <v-chip x-small label color="success" v-if='website.published' >published</v-chip>
      <v-chip x-small label color="amber" v-else >not published</v-chip>
    </v-list-item-subtitle>
  </v-list-item-content>
  <v-list-item-action v-if="website && website.id" >
    <v-btn icon small
      v-if='website.canonical_domain'
      :href="`https://${website.canonical_domain.name}`"
      target="_blank" >
      <v-icon small >mdi-open-in-new</v-icon>
    </v-btn>
  </v-list-item-action>
  <template v-else >
    <!-- <v-list-item-action >
      <v-btn x-small @click.stop="$emit('preview', data, website)" color="success" >
        preview
      </v-btn>
    </v-list-item-action> -->
    <v-list-item-action >
      <v-btn x-small color="primary" >
        create
      </v-btn>
    </v-list-item-action>
  </template>
</v-list-item>
</template>
<script>
export default {
  name: 'WebsiteListItem',
  props: {
    title: { type: String, required: true },
    websiteType: { type: String, required: true },
    data: { type: Object, required: true },
    website: { type: Object }
  }
}
</script>
